import styled from "@emotion/styled";
import { COLOR_MAP } from "../../../../constants/ColorNames";
import { Divider, FormControl, IconButton, MenuItem, Select, SelectChangeEvent, Stack, colors } from "@mui/material";
import { ADD_ICON } from '../../../../constants/icons/AddIcon'
import { DUSTBIN_ICON } from "../../../../constants/icons/DustinBin";
import AlertIcon from "../../../../constants/icons/AlertIcon";
import { NOT_ALLOWED_ICON } from "../../../../constants/icons/NotAllowedIcon";
import { renderToStaticMarkup } from "react-dom/server";
import { BootstrapTooltip } from "../../../../style/tooltips";



type TabProps = {
  handleDeleteFollowUp: (id: string) => void,
  handleAddFollowUp: () => void,
  handleTabClick: (id: string) => void
  tabState: {
    label: string,
    selectedFollowUPdays: string,
    subject: string,
    email: string,
    showError?: boolean,
  }[],
  selectedTab: string,
  handleSelectedDayChange: (e: SelectChangeEvent, label: string) => void,
  disabled?: boolean
}

const Container = styled(Stack)`
  display: flex;
  background-color: ${COLOR_MAP.PILL_Bk};
  border-radius: 0.4rem 0.4rem 0 0;
  border-bottom: 0.1rem solid ${COLOR_MAP.BORDER_GREY};
  padding-top:0.4rem ;
`

const ListContainer = styled(Stack)`
  margin: 0 1.6rem;
  &.selected{
    border-bottom: 0.2rem solid ${COLOR_MAP.DARK_PURPLE};
  }
  &.unselected{
    padding-bottom: 0.2rem;
  }
`

const List = styled(Stack)`
  list-style: none;
  font-weight: 500;
  font-size: 1.4rem;
  line-height:2rem ;
  cursor: pointer;
`

const Button = styled.button`
  font-weight: 600;
  font-size: 1.2rem;
  line-height:1.6rem ;
  border: none;
  color: ${COLOR_MAP.DARK_PURPLE};
  cursor: ${props => (props?.disabled ? `url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(NOT_ALLOWED_ICON))}"), auto` : 'inherit' )} ;
`

type ButtonContainerProps = {
disabled?: boolean;
}

const ButtonContainer = styled(Stack)<ButtonContainerProps>`
  padding: 0 1.6rem;
  display: flex;
  align-items: center;
  margin: 0 !important;
  flex-direction: row;
  cursor: ${props => (props?.disabled ? `url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(NOT_ALLOWED_ICON))}"), auto` : 'pointer' )} ;
  `
const StyledIconButton = styled(IconButton)`
  cursor: ${props => (props?.disabled ? `url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(NOT_ALLOWED_ICON))}"), auto` : 'pointer' )} ;
`

const Heading = styled(List)`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  color:${COLOR_MAP.GREY_2};
  &.selected{
    font-weight: 700;
  }
  &.unselected{
    font-weight: 500;
  }
`

const SubHeading = styled(List)`
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.6rem;
  padding-bottom: 1rem;
  padding-top: 0.3rem;
  display: flex;
  flex-direction: row;
  &.padding-top{
      padding-top: 0.8rem;
  }
`
const Tabs = (props: TabProps) => {
  const { handleDeleteFollowUp,
    handleAddFollowUp,
    handleTabClick,
    tabState,
    selectedTab,
    handleSelectedDayChange,
    disabled = false
  } = props
  return (
    <Container
      alignItems='center'
      flexDirection='row'
      gap={2}
      divider={
        <Divider
          style={{
            height: '3.2rem',
            marginTop: '0.8rem',
            backgroundColor: COLOR_MAP.LIGHT_BLUE
          }}
          orientation="vertical"
          flexItem
        />}>
      {tabState.map((tab, index) => {
        const isLast = index === tabState.length - 1;
        const isSelected = selectedTab === tab.label;
        const showError = tab.showError;

        const isEmailTab = tab.label === 'Email';

        return (
          <ListContainer className={isSelected ? 'selected' : 'unselected'}
          sx={{
            marginRight : (showError && isEmailTab) ? 0 : '1.6rem',
          }}
          onClick={() => handleTabClick(tab.label)}>
            <Heading className={isSelected ? 'selected' : 'unselected'}
            sx={{
              gap: (showError && isEmailTab) ? '1.2rem' : 0,
            }}
            >
              {tab.label}
              <div>
              {showError && <AlertIcon/>}
              {tab.label !== 'Email' && isLast
                && <span style={{ marginTop: '0.3rem', marginLeft: '1rem' }}
                  onClick={() => handleDeleteFollowUp(tab.label)}>
                  {DUSTBIN_ICON}
                </span>}
                </div>
            </Heading>
            <SubHeading className={tab.label === 'Email' ? 'padding-top' : ''} >
              {
                tab.label === 'Email' ?
                  'Today'
                  :
                  <Stack flexDirection='row'>
                    <Select
                      labelId="demo-simple-select-standard-label"
                      id="demo-simple-select-standard"
                      label="days"
                      variant="standard"
                      onChange={(e: SelectChangeEvent) => handleSelectedDayChange(e, tab.label)}
                      value={tab.selectedFollowUPdays}
                      sx={{
                        minWidth: '10rem',
                        padding: '0 !important',
                        "&:: before": {
                          borderBottom: '0'
                        },
                        "&:: after": {
                          borderBottom: '0'
                        },
                        fontSize: '1.2rem',
                        fontWeight: 400,
                        lineHeight: '1.6rem',
                        color: COLOR_MAP.GREY_DARK

                      }}
                    >
                      {[1, 2, 3, 4].map(item => (
                        <MenuItem sx={{
                          padding: '0.8rem !important'
                        }} value={item}>
                          {item} {item === 1 ? 'day' : 'days'} after {tab.label === 'Follow up-1' ? 'email' : `follow up-${+tab.label.split('-')[1] - 1}`}
                        </MenuItem>

                      ))}

                    </Select>
                  </Stack>
              }

            </SubHeading>

          </ListContainer>
        )
      })}
      {
        tabState.length < 5 && (
        <BootstrapTooltip title={disabled? <div style={{ fontSize: '14px', padding: '4px 8px', fontFamily: 'Noto Sans', lineHeight: '22px' }}>Please wait for the content to complete generating</div> : ''}>
        <ButtonContainer onClick={handleAddFollowUp} disabled={disabled}>
          <StyledIconButton disableRipple >
            {ADD_ICON}
          </StyledIconButton>
          <Button>Add follow-up</Button>
        </ButtonContainer>
      </BootstrapTooltip>
        )}
    </Container >)
}

export default Tabs;
